import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/header/index.tsx");
